//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { MU_UPATE_AUTH } from 'store/index.js';
export default {
  data: function data() {
    return {
      tabs: 1,
      schoolId: "",
      cardNum: "",
      displayName: "",
      Password: "",
      oldPassword: "",
      replayPass: "",
      schoolInfo: []
    };
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.auth;
    }
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch(MU_UPATE_AUTH).then(function () {
      _this.getSchoolInfo();
    });
  },
  methods: {
    //获取学校列表
    getSchoolInfo: function getSchoolInfo() {
      var that = this;
      this.$http.post("/api/XOrg/XLogin/getSchoolInfo").then(function (rst) {
        if (rst.code > 0) {
          that.schoolInfo = rst.schoolInfo;
          that.schoolId = that.userInfo.userSchoolId;
          that.cardNum = that.userInfo.cardNumber;
          that.displayName = that.userInfo.displayName;
        }
      });
    },
    editUserInfo: function editUserInfo() {
      var that = this;
      this.$http.post("/api/XOrg/PersonCenter/editUserInfo", {
        schoolId: this.schoolId,
        cardNum: this.cardNum,
        displayName: this.displayName
      }).then(function (rst) {
        if (rst.code > 0) {
          that.$message.success(rst.msg);
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    editPassword: function editPassword() {
      var that = this;

      if (this.oldPassword == "") {
        that.$message.warning("旧密码不可为空");
        return false;
      }

      if (this.Password == "") {
        that.$message.warning("新密码不可为空");
        return false;
      }

      if (this.replayPass == "") {
        that.$message.warning("请确认密码");
        return false;
      }

      if (this.Password != this.replayPass) {
        that.$message.warning("确认密码错误，请重新输入");
        that.replayPass = "";
        return false;
      }

      this.$http.post("/api/XOrg/PersonCenter/editPassword", {
        Password: this.Password,
        oldPassword: this.oldPassword
      }).then(function (rst) {
        if (rst.code > 0) {
          that.cancel();
          that.$message.success(rst.msg);
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    cancel: function cancel() {
      this.Password = "";
      this.oldPassword = "";
      this.replayPass = "";
    },
    //返回首页
    goHome: function goHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    getNewsr: function getNewsr(val) {
      this.tabs = val;
    }
  }
};